<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12">
        <p class="-mt-3 text-3.5xl font-semibold text-gray-900">
          Préconisation Emploi/Stage
        </p>
        <p class="mt-3 text-sm text-gray-600">
          Retrouvez ici la check-list des moyens mis en place de l'ensemble des
          carnets de parcours
        </p>
      </div>
      <img
        class="hidden xl:block absolute right-16 m-4 w-80"
        src="/assets/img/entreprise.png"
        alt=""
      />
    </div>
    <div class="flex flex-col my-15 ">
      <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 px-8">
        <div
          class="align-middle inline-block min-w-full shadow overflow-hidden rounded-lg border-b border-gray-200 bg-white"
        >
          <h3 class="mt-15 mb-15 w-full inputfloat clear-both">
            Check-list des moyens mis en place
          </h3>
          <div
            class="flex justify-center w-full text-center text-xl text-gray-600 font-medium cursor-pointer mb-10"
          >
            <div
              class="inputfloat"
              @click="displayTab('accessibilite')"
              :class="{ 'text-indigo-600': tab_display == 'accessibilite' }"
            >
            Accessibilite
            </div>
            <div
              class="inputfloat"
                @click="displayTab('poste de travail')"
                :class="{ 'text-indigo-600': tab_display == 'poste de travail' }"
            >
            Poste de travail
            </div>
            <div
              class="inputfloat"
              @click="displayTab('autonomie')"
              :class="{ 'text-indigo-600': tab_display == 'autonomie' }"
              >
              Autonomie
            </div>
          </div>
          <div class="input float clear-both w-full"></div>
            <div
              class="border-2 border-gray-600 border-opacity-50 border-dashed rounded mb-20 mx-40 p-10"
            >
              <div class="text-md text-indigo-600 font-semibold text-center">
                Total des moyens à mettre en place = 4
              </div>
              <div class="text-md font-semibold text-center">
                <br />
                <p>Non traités = 2</p>
                <p>En cours = 1</p>
                <p>Mis en place = 1</p>
              </div>
            </div>

            <div class="flex mt-16 mb-8 items-start justify-between">
              <div class="w-1/4 cursor-pointer inputfloat clear-both relative mb-10">
                <div class="relative w-full flex" @click="displayFilter=true">
                  <span class="inputfloat  text-teal-500 border rounded-full bg-teal-300 ml-10" style="padding:7px">
                    <icon name="height"/>
                  </span>
                  <span class="text text-gray-900 text-base font-semibold ml-3 mt-1.5">Filtres
                    <div class="text-teal-600 inline-block ml-2 dropdown-menu"><icon name="chevron-down" /></div>
                  </span>
                </div>
              </div>

                <div class="flex justify-between w-2/5 ">
                  <div class="relative w-1/2 text-gray-400 focus-within:text-gray-600 border border-gray-200 left-20">
                    <input
                      id="search_field"
                      v-model="search"
                      class="block w-full h-10 px-4 py-2 shadow-md rounded-md text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 sm:text-2sm"
                      placeholder="Rechercher un bénéficiaire"
                      type="search"
                    />
                    <div
                      v-show="!search"
                      class="absolute mr-2 inset-y-0 right-0 flex items-center pointer-events-none text-indigo-600">
                      <icon name="search" class="h-4 w-4 mr-1.5" />
                    </div>
                  </div>
                </div>


                <transition leave-active-class="duration-200">
                  <div
                    v-show="displayFilter"
                    class="z-30 fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center"
                  >
                  <!-- Background modal -->
                    <transition
                      enter-active-class="ease-out duration-300"
                      enter-class="opacity-0"
                      enter-to-class="opacity-100"
                      leave-active-class="ease-in duration-200"
                      leave-class="opacity-100"
                      leave-to-class="opacity-0"
                    >
                      <div v-show="displayFilter" class="fixed inset-0 transition-opacity" @click="displayFilter = false;">
                       <div class="absolute inset-0 bg-indigo-600 bg-opacity-85"></div>
                      </div>
                    </transition>
                  <!-- FIN Background modal -->

                  <!-- Content modal to add or edit a picture -->
                    <transition
                      enter-active-class="ease-out duration-300"
                      enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                      enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-active-class="ease-in duration-200"
                      leave-class="opacity-100 translate-y-0 sm:scale-100"
                      leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                      <div
                        v-if="displayFilter"
                        class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-visible shadow-xl transform transition-all lg:w-3/6 sm:w-full sm:p-6"
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="modal-headline"
                      >
                        <h3 class="my-16">Filtrer</h3>
                        <div class="bg-indigo-100 mx-40 items-center text-center w-auto h-auto mb-24 rounded-lg">
                          <label
                            class="inputfloat text-indigo-600 font-bold text-base clear-both "
                            for="filtre_intitule"
                            > Filtrer par intitulé
                          </label>

                          <input-text
                            class="inputfloat clear-both w-full -mt-1 mb-5"
                            name="filtre_intitule"
                            placeholder="Saisissez l'intitulé"
                          />
                          <div class="inputfloat w-full flex justify-between">
                            <div class="inputfloat w-1/2 flex-row">
                              <label
                                class="inputfloat relative w-full text-indigo-600 font-bold text-base clear-both -ml-20"
                                for="filtre_etat"
                                > Filtrer par état
                              </label>
                              <input-select
                                name="filtre_etat"
                                class="inputfloat w-full clear-both -ml-2"
                                :datas="[
                                  { value: 'Non traité' },
                                  { value: 'En cours' },
                                  { value: 'Mis en place'},
                                ]"
                              />
                            </div>
                            <div class="inputfloat w-1/2 flex-row">
                              <label
                                class="inputfloat relative w-full text-indigo-600 font-bold text-base -ml-16  "
                                for="filtre_delai"
                                > Filtrer par delai
                              </label>
                              <date-picker
                                name="filtre_delai"
                                class="inputfloat w-full clear-both ml-2"
                                format="dd/MM/yyyy"
                                initialview="year"
                              />
                            </div>
                          </div>
                          <div class="inputfloat w-full flex justify-center" >
                            <action-button
                                class="inputfloat relative flex flex-row mt-15 mb-15 p-5"
                                border-color="border-transparent"
                                text-color="text-white"
                                bg-color="bg-pink-600"
                                bg-color-square="bg-pink-600"
                                icon-color="text-white"
                                libelle="APPLIQUER LES FILTRES"
                                icon="arrow-right_1"
                                right=true
                            />
                          </div>
                        </div>
                      <div
class="cursor-pointer block absolute right-5 top-5
                        rounded-full px-2 py-2
                        bg-pink-100 text-pink-600 border border-pink-600 border-opacity-25
                        transition ease-in-out duration-500
                        hover:text-white hover:bg-pink-600"
                        @click="displayFilter = false;"
                      >
                        <icon name="close" />
                      </div>
                    </div>
                  </transition>
                  </div>
                </transition>
              </div>

        <!-- END Content modal -->




                <div class="text-base text-gray-600 font-medium">
                    <div class="inputfloat clear-both w-1/20"></div>
                    <div class="inputfloat w-2/12">Personne</div>
                    <div class="inputfloat w-1/12">Date</div>
                    <div class="inputfloat w-2/12">Intitulé</div>
                    <div
                        @mouseover="isDisplayCommentaireTooltip = true"
                        @mouseleave="isDisplayCommentaireTooltip = false"
                        class="inputfloat w-1/12"
                    >
                        <info-bulle-hover 
                            :is-display-tooltip="isDisplayCommentaireTooltip"
                            name="commentaireTooltip"
                            libelle="Commentaires"
                        />
                        Comm.
                    </div>
                    <div class="inputfloat w-2/12">Délai</div>
                    <div class="inputfloat w-2/12">Etat</div>
                    <div class="inputfloat w-1/12">Pass'up</div>
                </div>
                <div class="input float clear-both w-full"></div>

                <div
v-for="(a, num) in form"
                    :key="num"
                    class="odd:bg-indigo-100 odd:bg-opacity-50 inputfloat clear-both w-full"
                    style="padding: 0px!important"
                >
                    <div
                        class="h-16 lg:h-24 2xl:h-32 flex items-center cursor-default hover:bg-indigo-200"
                        :class="{'bg-indigo-200 border-l-2 border-indigo-600': itemDisplayed == num}"
                        @click="displayItem(num)"
                    >
                        <div class="inputfloat clear-both w-1/20 text-pink-600 text-center">
                            <icon
class="inline-block transform transition-transform ease-in-out duration-300"
                                :class="{'rotate-90': itemDisplayed == num}"
                                name="chevron-right"
                            />
                        </div>

                        <div class="inputfloat w-2/12 text-sm font-semibold flex">
                            <div class="h-10 w-10">
                                <!-- <img
                                class="h-10 w-10 rounded-full"
                                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                alt=""
                                /> -->
                                <icon name="user" class="h-10 w-10 text-indigo-600" />
                            </div>
                            <div class= "inputfloat mt-2.5 ml-3">
                            {{ value= 'Marie CURIEUX'}}
                            </div>
                        </div>
                        <div class="inputfloat w-1/12 text-sm text-gray-600 font-semibold ">
                            {{ value= '20/06/2020'}}
                        </div>
                        <div class=" inputfloat w-2/12 text-2sm font-bold italic">
                            {{ value= "Transport: repérage"}}
                        </div>
                        <div class="inputfloat text-gray-600 w-1/12 mb-10 mt-8 ml-2">
                            <icon name="message-circle"/>
                        </div>
                        <div class="inputfloat w-2/12 text-sm font-semibold" style="padding-left:5px">
                            {{ value= '20/12/2020'}}
                        </div>
                        <div class="inputfloat text-sm text-teal-600 bg-teal-300 rounded-lg border-solid border" style="padding: 5px 10px">
                            {{value= 'Mis en place'}}
                        </div>
                        <div class="inputfloat text-indigo-600 w-1/12" style="margin-left:150px;">
                            <icon name="layers"/>
                        </div>
                    </div>
                    <div
v-if="itemDisplayed == num"
                        class="inputfloat clear-both w-full bg-white">

                        <input-text-area
                        name="moyens_mettre_place"
                        libelle="Moyens à mettre en place"
                        size="3"
                        :value="a.moyens_mettre_place" @input="(newValue) => {a.moyens_mettre_place = newValue}"
                        class="w-full inputfloat clear-both"
                        />

                        <date-picker
                        name="delai_mise_place"
                        libelle="Délai de mise en place"
                        class="w-1/2 inputfloat"
                        format="yyyy"
                        min-view="year"
                        :value="a.delai_mise_place" @input="(newValue) => {a.delai_mise_place = newValue}"
                        />

                        <input-select
                        name="statut"
                        libelle="Statut"
                        size="3"
                        :value="a.statut" @input="(newValue) => {a.statut = newValue}"
                        :datas="[
                                { value: 'Non traité' },
                                { value: 'En cours' },
                                { value: 'Mis en place'},
                            ]"
                        class="w-1/2 inputfloat "
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../components/Inputs/InputText';
import InputTextArea from '../components/Inputs/InputTextArea';
import InputSelect from '../components/Inputs/InputSelect';
import MultipleSelect from '../components/Inputs/MultipleSelect';
import DatePicker from '../components/Inputs/DatePicker';
import CheckboxGreen from '../components/Inputs/CheckboxGreen';
import CheckboxForm from '../components/Inputs/CheckboxForm';
import Icon from '../components/Icon';
import IconComment from'../components/Inputs/IconComment';
import ActionButton from'../components/ActionButton';
import InfoBulleHover from '../components/InfoBulleHover.vue';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    IconComment,
    ActionButton,
    InfoBulleHover,

  },

  name: 'PrecoEmploiStage',

  data() {
    return {
      tab_display: 'accessibilite',
      itemDisplayed: -1,
      search: '',
      displayFilter: false,
      form: [
        {}
      ],
    };
  },
  mounted(){
    //each field saved is pasted in local form
    Object.assign(this.form, this.formContent);
  },
  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
    }),
    displayTab(nomPage) {
      this.tab_display = nomPage;
    },
    displayItem(numItem){
      if(this.itemDisplayed == numItem){
        this.itemDisplayed = -1;
      }else{
        this.itemDisplayed = numItem;
      }
    },

    computed:{
      ...mapGetters({
        formContent: 'neopass/formContent'
      }),
      datas_form(){
        return this.form.filter(content => content.type_preco == this.tab_display);
      }
    },
    watch:{
      form: {
        handler(){
          this.SET_FORMCONTENT(this.form);
          this.calculate_progress();
        },
        deep: true
      }
    }
  }
};
</script>
